import { HttpResponse } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, inject, input, signal } from '@angular/core';
import { DownloadDocumentService } from '@app/shared/service/download-document-service';
import { getFileNameFromContentDisposition } from '@app/time-sheet/util/pdf-util';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap/tooltip';

import saveAs from 'file-saver';
import { finalize } from 'rxjs';

import { TimeSheetTask } from '../../models/time-sheet-task';

@Component({
  selector: 'abc-download-button',
  imports: [NgbTooltipModule],
  templateUrl: 'download-button.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadButton {
  task = input.required<TimeSheetTask>();
  month = input.required<number>();
  year = input.required<number>();

  private downloadDocumentService = inject(DownloadDocumentService);

  isLoading = signal(false);

  generateAndDownloadTimeSheetTask() {
    this.isLoading.set(true);

    this.downloadDocumentService
      .downloadUnsignedTimeSheet(this.task().timesheetId)
      .pipe(finalize(() => this.isLoading.set(false)))
      .subscribe({
        next: (response: HttpResponse<Blob>) => {
          const blob = response.body;
          if (blob) {
            const filename = getFileNameFromContentDisposition(
              response.headers.get('Content-Disposition')
            );
            saveAs(blob, filename);
          }
        },
      });
  }
}
